<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-2xl text-gray-800 dark:text-gray-200 leading-tight">
                Edit client
            </h2>
        </template>
        <client-form :client="client" :all-tags="allTags"></client-form>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import ClientForm from "@/Pages/Admin/Client/Partials/ClientForm";


export default {
    components: {
        ClientForm,
        AppLayout,
    },
    props: {
        client: Object,
        allTags: Array,
    },
}
</script>
